<template>
  <div>
    <div class="container" :class="getCurrentModule">
      <div class="jumbotron" v-show="!closeJumbotron">
        <span class="top-right" @click="closeJumbo()">&times;</span>
        <p class="lead">
          På denna sida kan du hämta ut en statistikrapport med aggregerad data från FHabian.
        </p>
        <p class="lead">
          Det går ej att välja tidsperiod för rapporten utan här får du ut data från start till dagens datum.
        </p>
      </div>
      <!-- Kaskadscreening (gen positiv) -->
      <div class="card" v-if="getStatsByPath() === 'cascade'">
        <div class="card-header left">
          Statistik<sup class="sup">Kaskadscreening</sup>
        </div>
        <div class="card-body">
          <p class="card-text">
            <button class="btn btn-info btn-sm" @click="downloadExcel({ entry: 'cascade', type: 'national' })" :disabled="getReportPending">
              <img src="@/assets/img/excel.svg?data" alt="Ikon för Excel" class="img-fluid" /> Hämta ut statistik på nationell nivå
            </button>
          </p>
          <p class="card-text">
            <button class="btn btn-info btn-sm" @click="downloadExcel({ entry: 'cascade', type: 'clinic' })" :disabled="getReportPending">
              <img src="@/assets/img/excel.svg?data" alt="Ikon för Excel" class="img-fluid" /> Hämta ut statistik på klinik nivå
            </button>
          </p>
        </div>
      </div>
      <!-- Kaskadscreening (gen negativ) -->
      <div class="card" v-if="getStatsByPath() === 'gen_negative'">
        <div class="card-header left">
          Statistik<sup class="sup">Kaskadscreening (gen negativ)</sup>
        </div>
        <div class="card-body">
          <p class="card-text">
            <button class="btn btn-info btn-sm" @click="downloadExcel({ entry: 'gen_negative', type: 'national' })" :disabled="getReportPending">
              <img src="@/assets/img/excel.svg?data" alt="Ikon för Excel" class="img-fluid" /> Hämta ut statistik på nationell nivå
            </button>
          </p>
          <p class="card-text">
            <button class="btn btn-info btn-sm" @click="downloadExcel({ entry: 'gen_negative', type: 'clinic' })" :disabled="getReportPending">
              <img src="@/assets/img/excel.svg?data" alt="Ikon för Excel" class="img-fluid" /> Hämta ut statistik på klinik nivå
            </button>
          </p>
        </div>
      </div>
      <!-- Kardiolog -->
      <div class="card" v-if="getStatsByPath() === 'cardio'">
        <div class="card-header left">
          Statistik<sup class="sup">Kardiolog</sup>
        </div>
        <div class="card-body">
          <p class="card-text">
            <!-- TODO: Enable buttons when API endpoints are available -->
            <button class="btn btn-info btn-sm" @click="downloadExcel({ entry: 'cardio', type: 'national' })" :disabled="getReportPending">
              <img src="@/assets/img/excel.svg?data" alt="Ikon för Excel" class="img-fluid" /> Hämta ut statistik på nationell nivå
            </button>
          </p>
          <p class="card-text">
            <button class="btn btn-info btn-sm" @click="downloadExcel({ entry: 'cardio', type: 'clinic' })" :disabled="getReportPending">
              <img src="@/assets/img/excel.svg?data" alt="Ikon för Excel" class="img-fluid" /> Hämta ut statistik på klinik nivå
            </button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '../../config/index.js'
import axios from '../plugins/axios'
import FileSaver from 'file-saver'

export default {
  name: 'statistics',
  components: {
  },
  data () {
    return {
      closeJumbotron: (localStorage.getItem('jumbotron-closed-stats') === 'true') || false,
      getReportPending: false
    }
  },
  methods: {
    getStatsByPath () {
      if (this.$route) {
        const strippedPath = this.$route.path.replace(/\//g, '').replace(/[0-9]/g, '')
        if (strippedPath.includes('cardio')) {
          return 'cardio'
        } else if (strippedPath.includes('gen_negative')) {
          return 'gen_negative'
        } else {
          return 'cascade'
        }
      }
    },
    closeJumbo () {
      localStorage.setItem('jumbotron-closed-stats', true)
      this.closeJumbotron = true
    },
    downloadExcel (info) {
      this.getReportPending = true
      let baseUri = ''
      let statsUri = ''
      let filename = ''
      switch (info.entry) {
        case 'cascade':
          baseUri = config.dashboardUri
          filename = 'Excelstatistik-GenPositiv-'
          if (info.type === 'national') {
            statsUri = config.excelStatUri
          } else {
            statsUri = config.excelStatByClinicianUri
          }
          break
        case 'cardio':
          baseUri = config.cardioUri
          filename = 'Excelstatistik-Kardiologi-'
          if (info.type === 'national') {
            statsUri = config.excelStatUri
          } else {
            statsUri = config.excelStatByClinicianUri
          }
          break
        case 'gen_negative':
          baseUri = config.geneNegativeUri
          filename = 'Excelstatistik-GenNegativ-'
          if (info.type === 'national') {
            statsUri = config.excelStatUri
          } else {
            statsUri = config.excelStatByClinicianUri
          }
          break
        default:
          window.location.href = window.location.origin.concat('/error')
          break
      }
      axios.getBlob(baseUri + statsUri).then(response => {
        if (response) {
          FileSaver.saveAs(response.data, filename + new Date().toISOString('YYYY-MM-DD').slice(0, 10) + '.xlsx')
          this.getReportPending = false
        }
      }).catch((error) => {
        if (error) {
          this.getReportPending = false
          console.log('Could not get report: ' + error)
        }
      })
    }
  },
  computed: {
    getCurrentModule () {
      if (this.$route.path.includes('gen_negative')) {
        return 'bg--gen-negative'
      } else if (this.$route.path.includes('cardio')) {
        return 'bg--cardio'
      }
      return 'bg--gen-positive'
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.card-header {
  font-size: 1.2em;
}
.sup {
  font-size: 0.5em;
  vertical-align: 5px;
}
.btn {
  min-width: 20vw;
}
.top-right {
  position: absolute;
  top: 0;
  right: 0;
  margin: 5px 15px 0px 0px;
  cursor: pointer;
  transform: scale(1.5);
}
</style>



// WEBPACK FOOTER //
// src/components/Statistics.vue